export const TAGS = {
  PWC_CUSTOMERS: 'pwcCustomers',
};
